import type { UserProfile } from "@/services/authService";

export type LayoutContentState =
  | "loading-profile"
  | "refreshing"
  | "profile-unavailable"
  | "ready";

interface LayoutContentStateInput {
  isLoading: boolean;
  userProfile: UserProfile | null;
}

export function resolveLayoutContentState({
  isLoading,
  userProfile,
}: LayoutContentStateInput): LayoutContentState {
  if (isLoading) {
    return userProfile ? "refreshing" : "loading-profile";
  }

  return userProfile ? "ready" : "profile-unavailable";
}
